/* tslint:disable */
/* eslint-disable */
/**
 * Telematics API
 * Telematics services API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PublishToManyTarget
 */
export interface PublishToManyTarget {
    /**
     * 
     * @type {string}
     * @memberof PublishToManyTarget
     */
    user: string;
    /**
     * 
     * @type {string}
     * @memberof PublishToManyTarget
     */
    device?: string;
}

export function PublishToManyTargetFromJSON(json: any): PublishToManyTarget {
    return PublishToManyTargetFromJSONTyped(json, false);
}

export function PublishToManyTargetFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublishToManyTarget {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user': json['user'],
        'device': !exists(json, 'device') ? undefined : json['device'],
    };
}

export function PublishToManyTargetToJSON(value?: PublishToManyTarget | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user': value.user,
        'device': value.device,
    };
}


